import { MdOutlineArrowOutward } from "react-icons/md";

import { Typography } from "antd";
import PrimaryButton from "../Forms/PrimaryButton";

const { Title } = Typography;

const Delete = ({
  text,
  handleSubmit,
  assignedSalesPerson,
  pageName = "this page",
  recordName = "this record",
  recordDetails,
  loading,
}) => {
  const isAllowEdit = text === "Allow Edit Access";
  const isRemoveEdit = isAllowEdit && recordDetails?.is_edit_allowed === 1;
  return (
    <>
      <Title level={2} className="w-full text-left font-abhaya !mb-0">
        {isRemoveEdit
          ? "Remove Edit Access"
          : isAllowEdit
          ? "Allow Edit Access"
          : pageName === "Salesperson"
          ? "Delete Salesperson"
          : "Delete Client"}
      </Title>
      <p className="w-full text-left text-base mt-2 mb-4">
        {text === "Allow Edit Access" ? (
          <>
            Assigned Salesperson - <span className="font-bold">{assignedSalesPerson}</span>
          </>
        ) : (
          <>
            Do you want to delete <span className="font-bold">{recordName}</span> from{" "}
            <span className="font-bold">
              {pageName === "Salesperson" ? "Sales Employees" : "Clients"}
            </span>
            ?
          </>
        )}
      </p>
      <div className="w-full flex justify-center">
        <PrimaryButton
          text={text == "Allow Edit Access" ? "Update Access" : "Delete"}
          onClick={handleSubmit}
          loading={loading}
          className="me-[30px]"
        />
      </div>
    </>
  );
};

export default Delete;
